import { shouldUseDemoModeForRequest } from '@/utils/demo-mode';
import { InternalAxiosRequestConfig } from 'axios';

export const demoModeInterceptor = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  if (!shouldUseDemoModeForRequest(config)) {
    return config;
  }

  const demoAccountId = process.env.REACT_APP_DEMO_ACCOUNT_ID;
  const demoBearerToken = process.env.REACT_APP_DEMO_BEARER_TOKEN;

  if (!demoAccountId || !demoBearerToken) {
    return config;
  }

  // Override Authorization header
  config.headers.set('Authorization', `Bearer ${demoBearerToken}`);
  config.headers.set('x-current-account-id', demoAccountId);

  if (config.params) {
    // Override accountID in params
    if (config.params.accountId) config.params.accountId = demoAccountId;
    if (config.params.accountID) config.params.accountID = demoAccountId;

    // Override account in filters
    if (config.params.filters && typeof config.params.filters === 'string') {
      try {
        const parsed = JSON.parse(config.params.filters);

        if (Array.isArray(parsed)) {
          parsed.forEach((filter) => {
            if (filter?.field === 'account' && filter?.value) {
              filter.value = demoAccountId;
            }
          });
          config.params.filters = JSON.stringify(parsed);
        }
      } catch {
        // Not valid JSON, ignore
      }
    }
  }

  // Override accountID in POST request body ( only report export requests currently )
  if (config.method?.toLowerCase() === 'post' && config.data) {
    try {
      const bodyData =
        typeof config.data === 'string' ? JSON.parse(config.data) : config.data;

      if (bodyData.filters && Array.isArray(bodyData.filters)) {
        bodyData.filters.forEach((filter: { field: string; value: string }) => {
          if (filter?.field === 'account' && filter?.value) {
            filter.value = demoAccountId;
          }
        });

        config.data =
          typeof config.data === 'string' ? JSON.stringify(bodyData) : bodyData;
      }
    } catch {
      // Not valid JSON, ignore
    }
  }

  // Override accountID in URL path
  if (config.url) {
    config.url = config.url.replace(
      /(\/|^)(account|accounts)\/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/gi,
      (_, slash, prefix) => {
        return `${slash || '/'}${prefix}/${demoAccountId}`;
      },
    );
  }

  return config;
};
